import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useState } from 'react';
import DialogHeader from '../Modals/DialogHeader';

interface Iprops {
  open: boolean;
  onClose: () => void;
  onSubmit?: (value) => void;
  files: [];
}
const CreateNewFile = ({ open, onClose, onSubmit, files }: Iprops) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const onNameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const validate = () => {
    if (name.trim().length === 0) {
      setError(true);
      setHelperText('File name is required');
      return false;
    }
    const parts = name.split('.');
    const fileName = `${parts[0].replace(' ', '-')}.py`;
    const isAlreadyExits = files.find((f) => f.fileName === fileName);
    if (isAlreadyExits) {
      setError(true);
      setHelperText('File Name already exits');
      return false;
    }
    setError(false);
    setHelperText('');
    return true;
  };

  const submit = () => {
    if (onSubmit && validate()) {
      onSubmit(name);
    }
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader onClose={() => onClose()}>
        <div>Create a new Source File</div>
      </DialogHeader>
      <DialogContent dividers>
        <TextField size="small" fullWidth label="File Name *" onChange={onNameChange} error={error} helperText={helperText} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button variant="contained" type="button" onClick={submit}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateNewFile;
